require('./mortgageRequestProgressBar.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { isEqual } = require('lodash/lang');

//@constants
const { HOLDER_OPTION_ONE, HOLDER_OPTION_TWO } = require('constants/mortgageRequestPreApproval').mortgageRequestPreApprovalCommons;
const { DATE_OF_BIRTH, HOME_OWNER_SHIP, WORK, MARITAL, INCOMES_AND_EXPENSES,
    OTHER_LOANS_AND_MORTGAGES } = require('constants/mortgageRequestPreApproval').idModalsMortgageRequest;

class MortgageRequestProgressBar extends React.Component {

    validatePositionIconTruck() {
        const { immMortgageRequest } = this.props;
        const idModalActive = immMortgageRequest.get('isModalActive');
        return classNames('mortgage-request-progress-bar__icon-truck',
            { 'mortgage-request-progress-bar__icon-second-position': isEqual(idModalActive, MARITAL) },
            { 'mortgage-request-progress-bar__icon-third-position': isEqual(idModalActive, HOME_OWNER_SHIP) },
            { 'mortgage-request-progress-bar__icon-fourth-position': isEqual(idModalActive, WORK) },
            { 'mortgage-request-progress-bar__icon-fifth-position': isEqual(idModalActive, INCOMES_AND_EXPENSES) },
            { 'mortgage-request-progress-bar__icon-sixth-position': isEqual(idModalActive, OTHER_LOANS_AND_MORTGAGES) }
        );
    }

    validateStateStation(idModalValidate) {
        const { immMortgageRequest } = this.props;
        const idModalActive = immMortgageRequest.get('isModalActive');
        const validModals = immMortgageRequest.get('validModals');

        const isCurrentStep = isEqual(idModalActive, idModalValidate);
        const isCompleteStep = validModals.getIn([idModalValidate, 'filled'], false);
        const firstHolderComplete = validModals.getIn([idModalValidate, 'fields', HOLDER_OPTION_ONE, 'semiComplete'], false);

        if (isEqual(immMortgageRequest.get('selectedHolder'), HOLDER_OPTION_ONE)) {

            return classNames(
                { "mortgage-request-progress-bar__current-station": isCurrentStep },
                { "mortgage-request-progress-bar__complete-station": !isCurrentStep && isCompleteStep },
                { "mortgage-request-progress-bar__semi-complete-station": !isCurrentStep && !isCompleteStep && (firstHolderComplete) },
                { "mortgage-request-progress-bar__incomplete-station": !isCurrentStep && !isCompleteStep }
            );

        } else {

            const secondHolderComplete = validModals.getIn([idModalValidate, 'fields', HOLDER_OPTION_TWO, 'semiComplete'], false);

            return classNames(
                { "mortgage-request-progress-bar__current-station": isCurrentStep },
                { "mortgage-request-progress-bar__complete-station": !isCurrentStep && isCompleteStep },
                { "mortgage-request-progress-bar__semi-complete-station": !isCurrentStep && !isCompleteStep && (firstHolderComplete || secondHolderComplete) },
                { "mortgage-request-progress-bar__incomplete-station": !isCurrentStep && !isCompleteStep }
            );

        }


    }

    render() {
        const { responsiveMobileVersion } = this.props;

        const positionIconTruck = this.validatePositionIconTruck();

        const classNameBirthForm = this.validateStateStation(DATE_OF_BIRTH);
        const classNameMaritialStatusForm = this.validateStateStation(MARITAL);
        const classNameOwnerHousingForm = this.validateStateStation(HOME_OWNER_SHIP);
        const classNameLaboralSituationForm = this.validateStateStation(WORK);
        const classNameincomeAndExpensesForm = this.validateStateStation(INCOMES_AND_EXPENSES);
        const classNameOtherLoansForm = this.validateStateStation(OTHER_LOANS_AND_MORTGAGES);

        return (
            <div className={responsiveMobileVersion ? "mortgage-request-progress-bar__progress-bar-center" : "mortgage-request-progress-bar"}>
                <div>
                    <div>
                        <div className={positionIconTruck}></div>
                    </div>
                    <div className="mortgage-request-progress-bar__container-stations">
                        <div id="birthForm" className={`mortgage-request-progress-bar__first-station ` + classNameBirthForm} />
                        <div id="maritialStatusForm" className={classNameMaritialStatusForm} />
                        <div id="ownerHousingForm" className={classNameOwnerHousingForm} />
                        <div id="laboralSituationForm" className={classNameLaboralSituationForm} />
                        <div id="incomeAndExpensesForm" className={classNameincomeAndExpensesForm} />
                        <div id="otherLoansForm" className={`mortgage-request-progress-bar__last-station ` + classNameOtherLoansForm} />
                    </div>
                </div>
                <div>
                    <i className="icon-casa-hogar mortgage-request-progress-bar__icon-home"></i>
                </div>
            </div>
        );
    }
}

MortgageRequestProgressBar.propTypes = {
    immMortgageRequest: PropTypes.object.isRequired
}

module.exports = MortgageRequestProgressBar;
